import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";

export interface OperationMergeRequestModel {
	readonly mergeCollectionId: string;
}

export interface OperationMergeRequestProperties {
	readonly requestModel: OperationMergeRequestModel;
	readonly collectionId: string;
}

export const useOperationMerge = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse, OperationMergeRequestProperties> = (requestProperties: OperationMergeRequestProperties) => {
		return http<undefined, OperationMergeRequestModel>({
			method: "POST",
			url: "/collection/" + requestProperties.collectionId + "/operation/merge",
			body: requestProperties.requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: (_, requestProperties) => {
			queryClient.invalidateQueries({ queryKey: ["dashboardCurrentPosition"] });
			queryClient.invalidateQueries({ queryKey: ["dashboardHistoricalPositions"] });
			queryClient.invalidateQueries({ queryKey: ["dashboardPerformanceDeltas"] });
			queryClient.invalidateQueries({ queryKey: ["transactionSummaries"] });
			queryClient.invalidateQueries({ queryKey: ["transactions", requestProperties.collectionId] });
			queryClient.invalidateQueries({ queryKey: ["collections"] });
			queryClient.invalidateQueries({ queryKey: ["collectionsPerformanceDelta"] });
			queryClient.invalidateQueries({ queryKey: ["collection", requestProperties.collectionId] });
			queryClient.invalidateQueries({ queryKey: ["collectionVariantDetails", requestProperties.collectionId] });
		}
	});
};
